import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import styled from 'styled-components';
import { styles } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import RouterTabs from '../../../components/RouterTabs';
import Receiving from './Receiving/Receiving';
import Blocking from './Blocking/Blocking';
import Throwing from './Throwing/Throwing';

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 20px 20px 0;
    h2 {
        font-weight: bold;
        margin-right: 25px;
    }
`;

const CatcherStrengths = ({ match: { path, url } }) => {
    const { t: translate } = useTranslation();

    const tabs = [{
        key: 'receiving',
        path: `${url}/receiving`,
        title: translate('sections.reports.catcher.receiving-title'),
        component: () => <Receiving />,
    }, {
        key: 'blocking',
        path: `${url}/blocking`,
        title: translate('sections.reports.catcher.blocking-title'),
        component: () => <Blocking />,
    }, {
        key: 'throwing',
        path: `${url}/throwing`,
        title: translate('sections.reports.catcher.throwing-title'),
        component: () => <Throwing />,
    }];

    return (
        <>
            <Header>
                <h2>{translate('sections.reports.catcher.catcher-strengths')}</h2>
            </Header>
            <Route path={path} render={() => <Redirect to={{ pathname: `${url}/receiving` }} />} />
            <div className="text-center">
                <RouterTabs tabs={tabs} activeColor={styles.theme.background.gallery} />
            </div>
        </>
    );
};

export default CatcherStrengths;
